import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

const CardLoader = ({ lines }) => {
  const cards = [];
  for (let x = 0; x < lines; x++) {
    cards.push(
      <ContentLoader
        key={x}
        height={27}
        width={400}
        speed={2}
        primaryColor="#e8ecef"
        secondaryColor="#afc0cc"
        className="v-sm-margin"
      >
        <rect x="0" y="0" rx="4" ry="4" width="400" height="10" />
        <rect x="0" y="14" rx="4" ry="4" width="280" height="8" />
      </ContentLoader>,
    );
  }
  return cards;
};

CardLoader.propTypes = {
  lines: PropTypes.number,
};

CardLoader.defaultProps = {
  lines: 10,
};

export default CardLoader;



// WEBPACK FOOTER //
// ./src/components/loaders/CardLoader.js